@if (!collapsed && !!checkedWrittenDates?.length) {
  <p>Relevant Written Dates:</p>
  <ul>
    @for (checkedWrittenDate of checkedWrittenDates; track checkedWrittenDate) {
      <li>
        {{ checkedWrittenDate.date | date: 'M/d/yyyy' }}
        @if (checkedWrittenDate.dateWithinRange) {
          <fa-icon
            [icon]="['fas', 'check']" size="1x" class="check ms-2" />
        }
        @if (checkedWrittenDate.dateWithinRange === false) {
          <fa-icon
            [icon]="['fas', 'exclamation-triangle']" size="1x" class="warning ms-2" />
        }
      </li>
    }
  </ul>
}
